import React, { createContext, useContext, useEffect, useState } from 'react';
import { IMAGES, SOUNDS, VIDEOS } from './Assets';

// Create a Context for assets
const AssetContext = createContext();

const preloadImages = imageUrls => {
  return Promise.all(
    imageUrls.map(
      src =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.src = src;
          img.onload = () => resolve(src);
          img.onerror = () => reject(new Error(`Failed to load ${src}`));
        }),
    ),
  );
};

const preloadVideos = videoUrls => {
  return Promise.all(
    videoUrls.map(
      src =>
        new Promise((resolve, reject) => {
          const video = document.createElement('video');
          video.src = src;
          video.preload = 'auto';
          video.oncanplaythrough = () => resolve(src);
          video.onerror = () => reject(new Error(`Failed to load ${src}`));
        }),
    ),
  );
};

const preloadAudios = audioUrls => {
  return Promise.all(
    audioUrls.map(
      src =>
        new Promise((resolve, reject) => {
          const audio = new Audio();
          audio.src = src;
          audio.preload = 'auto';
          audio.oncanplaythrough = () => resolve(src);
          audio.onerror = () => reject(new Error(`Failed to load ${src}`));
        }),
    ),
  );
};

export const AssetProvider = ({ children }) => {
  const [assetsLoaded, setAssetsLoaded] = useState(false);
  const [progress, setProgress] = useState(0);
 
  const loadAssets = async () => {
    try {
        const assets = {
            images: IMAGES.map(item => item.image),
            videos: VIDEOS.map(item => item.video),
            audios: SOUNDS.map(item => item.sound),
          };

        const totalAssets = assets.images.length + assets.videos.length + assets.audios.length;
        let loadedAssets = 0;

        const updateProgress = () => {
            loadedAssets++;
            setProgress((loadedAssets / totalAssets) * 100);
        };

        await Promise.all([
            preloadImages(assets.images).then(updateProgress),
            preloadVideos(assets.videos).then(updateProgress),
            preloadAudios(assets.audios).then(updateProgress),
        ]);

        setAssetsLoaded(true);
    } catch (err) {
        console.error("Asset preloading error:", err);
    }
};


  return <AssetContext.Provider value={{ assetsLoaded, progress , loadAssets }}>{children}</AssetContext.Provider>;
};

export const useAssets = () => useContext(AssetContext);
